import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-text',
  templateUrl: './fh-text.component.html',
  styleUrls: ['./fh-text.component.scss']
})
export class FhTextComponent {
  @Input() text: any;
  @Input() class = '';
  @Input() type: 'PAGE-TITLE' | 'PAGE-DESCRIPTION' | 'TITLE' | 'TEXT' | 'SECTION-TITLE' | 'CARD-TITLE' | 'CARD-DESCRIPTION' | 'SMALL' = 'TEXT';
  @Input() id: string = '';
}
